import React from 'react'

const CustomIntegration = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={40}
                height={40}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className="hovered-paths"
            >
                <g>
                    <path
                        d="M300.899 472.072c-16.647 0-29.931-14.451-28.065-31.531 1.432-13.115 12.013-23.633 25.096-24.978 6.643-.683 12.871.957 17.995 4.195V316.116h-76.83c-3.981 0-6.618 3.998-5.202 7.718 1.751 4.6 2.561 9.665 2.191 14.963-1.206 17.246-15.146 31.206-32.34 32.377-20.357 1.388-37.3-14.767-37.3-34.892 0-4.4.813-8.608 2.293-12.485 1.414-3.703-1.247-7.681-5.212-7.681h-30.159a5.613 5.613 0 0 0-5.613 5.613v161.323c0 12.061 9.746 21.838 21.769 21.838h166.403v-37.165a28.034 28.034 0 0 1-15.026 4.347z"
                        style={{}}
                        fill="#7a6d79"
                        data-original="#7a6d79"
                    />
                    <path
                        d="M446.511 316.116a44.286 44.286 0 0 0 7.763-25.113c.001-24.518-20.208-44.612-44.646-44.404-24.269.207-43.879 20.007-43.879 44.403 0 9.323 2.87 17.97 7.763 25.114h-57.586v103.643c-5.124-3.238-11.352-4.878-17.995-4.195-13.083 1.345-23.663 11.862-25.096 24.978-1.866 17.08 11.418 31.531 28.065 31.531a28.036 28.036 0 0 0 15.026-4.347v37.165h166.403c12.022 0 21.769-9.777 21.769-21.838V316.116h-57.587z"
                        style={{}}
                        fill="#ffd15b"
                        data-original="#ffd15b"
                    />
                    <path
                        d="M464.097 316.116v166.936c0 12.061-9.746 21.838-21.769 21.838h40c12.022 0 21.769-9.777 21.769-21.838V316.116h-40z"
                        style={{}}
                        fill="#ffc344"
                        data-original="#ffc344"
                    />
                    <path
                        d="M177.461 67.644a34.837 34.837 0 0 1 11.069 1.112c3.593.961 7.142-1.637 7.142-5.357V13.113c0-3.1-2.513-5.613-5.613-5.613H29.269C17.246 7.5 7.5 17.277 7.5 29.338v161.323c0 3.1 2.513 5.613 5.613 5.613h39.465c-4.463 6.331-6.892 14.209-6.299 22.681 1.206 17.246 15.146 31.205 32.34 32.377 20.357 1.387 37.3-14.768 37.3-34.892a34.882 34.882 0 0 0-6.387-20.166h80.528c3.1 0 5.613-2.513 5.613-5.613v-48.908c0-3.698-3.51-6.372-7.08-5.41a34.689 34.689 0 0 1-9.034 1.191c-20.046 0-36.14-16.972-34.784-37.374 1.156-17.422 15.312-31.49 32.686-32.516z"
                        style={{}}
                        fill="#c8effe"
                        data-original="#c8effe"
                    />
                    <path
                        d="M177.461 67.644a34.837 34.837 0 0 1 11.069 1.112c3.594.961 7.142-1.637 7.142-5.357V13.113c0-3.1-2.513-5.613-5.613-5.613h-40c3.1 0 5.612 2.513 5.612 5.613V63.4c0 3.72-3.548 6.318-7.142 5.357a34.837 34.837 0 0 0-11.069-1.112c-17.374 1.026-31.53 15.094-32.688 32.515-1.356 20.402 14.738 37.374 34.784 37.374 3.125 0 6.153-.415 9.034-1.191 3.571-.962 7.08 1.712 7.08 5.41v48.908c0 3.1-2.513 5.613-5.612 5.613h40c3.1 0 5.613-2.513 5.613-5.613v-48.908c0-3.698-3.51-6.372-7.08-5.41a34.689 34.689 0 0 1-9.034 1.191c-20.046 0-36.14-16.972-34.784-37.374 1.158-17.422 15.314-31.49 32.688-32.516z"
                        style={{}}
                        fill="#99e6fc"
                        data-original="#99e6fc"
                    />
                    <path
                        d="M315.925 132.955v58.432a34.652 34.652 0 0 0-18.211-3.9c-17.374 1.026-31.53 15.094-32.688 32.515-1.356 20.402 14.738 37.374 34.784 37.374a34.61 34.61 0 0 0 16.114-3.962v62.703h57.586a44.286 44.286 0 0 1-7.763-25.113c-.001-24.518 20.208-44.612 44.647-44.404 24.269.207 43.879 20.008 43.879 44.403 0 9.323-2.869 17.97-7.763 25.114h57.586V149.18c0-12.061-9.746-21.838-21.769-21.838H321.538a5.613 5.613 0 0 0-5.613 5.613z"
                        style={{}}
                        fill="#fd8087"
                        data-original="#fd8087"
                    />
                    <path
                        d="M482.328 127.342h-40c12.022 0 21.769 9.777 21.769 21.838v166.935h40V149.18c0-12.061-9.746-21.838-21.769-21.838z"
                        style={{}}
                        fill="#fe646f"
                        data-original="#fe646f"
                    />
                    <circle
                        cx="162.5"
                        cy="249.5"
                        r="19.092"
                        style={{}}
                        fill="#6fd7a3"
                        data-original="#6fd7a3"
                    />
                    <circle
                        cx="455.628"
                        cy="65.086"
                        r="19.092"
                        style={{}}
                        fill="#6fd7a3"
                        data-original="#6fd7a3"
                    />
                    <circle
                        cx="246.908"
                        cy="26.592"
                        r="19.092"
                        style={{}}
                        fill="#ffd15b"
                        data-original="#ffd15b"
                    />
                    <path
                        d="M7.5 89.973v100.688c0 3.1 2.513 5.613 5.613 5.613h39.465c-4.463 6.331-6.892 14.209-6.299 22.681 1.206 17.246 15.146 31.206 32.34 32.377 20.357 1.387 37.3-14.767 37.3-34.892a34.882 34.882 0 0 0-6.387-20.166h80.528c3.1 0 5.613-2.513 5.613-5.613v-48.908c0-3.698-3.51-6.372-7.08-5.41a34.689 34.689 0 0 1-9.034 1.191c-20.046 0-36.14-16.972-34.784-37.374 1.158-17.421 15.314-31.489 32.688-32.515a34.837 34.837 0 0 1 11.069 1.112c3.594.961 7.142-1.637 7.142-5.357V13.113c0-3.1-2.513-5.613-5.613-5.613H29.269C17.246 7.5 7.5 17.277 7.5 29.338v30.687M301.302 471.683c-16.647 0-29.931-14.451-28.065-31.531 1.432-13.115 12.013-23.633 25.096-24.978 6.643-.683 12.871.957 17.995 4.195V315.726h-76.83c-3.981 0-6.618 3.998-5.202 7.718 1.751 4.6 2.561 9.665 2.191 14.963-1.206 17.246-15.146 31.206-32.34 32.377-20.357 1.388-37.3-14.767-37.3-34.892 0-4.4.813-8.608 2.293-12.485 1.414-3.703-1.247-7.681-5.212-7.681h-30.159a5.613 5.613 0 0 0-5.613 5.613v161.323c0 12.061 9.746 21.838 21.769 21.838h166.403v-37.165a28.034 28.034 0 0 1-15.026 4.348z"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className="hovered-path"
                    />
                    <path
                        d="M504.5 410.644v-94.917h-57.586a44.296 44.296 0 0 0 7.763-25.113c0-24.518-20.208-44.612-44.646-44.404-24.269.207-43.879 20.007-43.879 44.403 0 9.323 2.87 17.97 7.763 25.114h-57.586V419.37c-5.124-3.238-11.352-4.877-17.995-4.195-13.083 1.344-23.663 11.862-25.096 24.978-1.865 17.08 11.418 31.531 28.065 31.531a28.036 28.036 0 0 0 15.026-4.347V504.5h166.403c12.022 0 21.769-9.777 21.769-21.838v-42.087"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className="hovered-path"
                    />
                    <path
                        d="M316.328 132.565v58.432a34.652 34.652 0 0 0-18.211-3.9c-17.374 1.026-31.53 15.094-32.688 32.515-1.356 20.402 14.738 37.374 34.784 37.374a34.61 34.61 0 0 0 16.114-3.962v62.703h57.586a44.286 44.286 0 0 1-7.763-25.113c-.001-24.518 20.208-44.612 44.647-44.404 24.269.207 43.879 20.008 43.879 44.403 0 9.323-2.869 17.97-7.763 25.114H504.5V148.791c0-12.061-9.746-21.838-21.769-21.838h-160.79a5.611 5.611 0 0 0-5.613 5.612zM281 147.667v-34.602l47.979-47.979H436"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className="hovered-path"
                    />
                    <circle
                        cx="455.628"
                        cy="65.086"
                        r="19.092"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className="hovered-path"
                    />
                    <path
                        d="M246.908 159.667v-114"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className="hovered-path"
                    />
                    <circle
                        cx="246.908"
                        cy="26.592"
                        r="19.092"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className="hovered-path"
                    />
                    <path
                        d="M201 328v-40l-25-25"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className="hovered-path"
                    />
                    <circle
                        cx="162.5"
                        cy="249.5"
                        r="19.092"
                        style={{
                            strokeWidth: 15,
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            strokeMiterlimit: 10
                        }}
                        fill="none"
                        stroke="#000000"
                        strokeWidth={15}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeMiterlimit={10}
                        data-original="#000000"
                        className="hovered-path"
                    />
                </g>
            </svg>

        </>
    )
}

export default CustomIntegration